
import { Component, Vue } from 'vue-property-decorator';
import ClientCompanyDetailsEditor from '@/app/components/settings/client/ClientCompanyDetailsEditor.vue';
import { Client, UploadedFile, ClientFileCategories } from 'ah-api-gateways';
import FileUploadCounter from 'ah-common-lib/src/common/components/upload/FileUploadCounter.vue';
import DocumentsUploader from '@/app/components/settings/client/DocumentsUploader.vue';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';

@Component({
  components: {
    ClientCompanyDetailsEditor,
    FileUploadCounter,
    DocumentsUploader,
  },
})
export default class CompanyClientInformationSettingsView extends Vue {
  private files: UploadedFile[] = [];

  get individualSettingsStore() {
    return useIndividualSettingsStore();
  }

  get supportEmail() {
    return this.$theme.val.helpEmail || 'info@alt21.com';
  }

  get client() {
    return this.individualSettingsStore.client;
  }

  get companyFileCategories() {
    return [
      ClientFileCategories.SAMPLE_INVOICE,
      ClientFileCategories.INCORPORATED_DOCUMENT,
      ClientFileCategories.FINANCIAL_STATEMENT,
    ];
  }

  get numberOfFiles() {
    return this.files.filter((file) => this.companyFileCategories.includes(file.category as ClientFileCategories))
      .length;
  }

  created() {
    this.individualSettingsStore.loadClient(true);
  }

  onClientSaved(client: Client) {
    this.individualSettingsStore.setClient(client);
    this.$toast.success('Client updated successfully');
  }
}
